import { render, staticRenderFns } from "./DoctorsEdit.vue?vue&type=template&id=56a0a263&"
import script from "./DoctorsEdit.vue?vue&type=script&lang=js&"
export * from "./DoctorsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports